import { QueryClient, QueryFunctionContext } from "@tanstack/react-query"
import { getAuth, getIdToken } from "firebase/auth"
import { app } from "@/common/lib/firebase/firebase"

// Use a more generic type for the context parameter.
const defaultQueryFn = async ({ queryKey }: QueryFunctionContext) => {
    const auth = getAuth(app)
    let token = ""

    const endpoint = queryKey[0] as string

    if (auth.currentUser !== null) {
        token = await getIdToken(auth.currentUser)
    } else {
        localStorage.removeItem("your_session_key")
        return Promise.reject(new Error("No authenticated user"))
    }

    const response = await fetch(endpoint, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })

    if (!response.ok) throw new Error("Network response was not ok")
    return response.json()
}

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            queryFn: defaultQueryFn,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 5,
            gcTime: 1000 * 60 * 10,
            retry: 3,
            retryDelay: (attemptIndex) =>
                Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
        },
    },
})
